import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import tabArrow from "../../assets/icons/tab-arrow.svg";

interface Props {
  arrowText: string;
}

const TabText = (props: Props) => {
  const { arrowText } = props;
  return (
    <Stack
      sx={{
        marginTop: "15px",
        marginBottom: "15px",
        display: "flex",
        height: "auto",
        justifyContent: "center",
        alignSelf: "center",
        justifyItems: "center",
        maxWidth: { xs: "100%" },
      }}
    >
      <img src={tabArrow} style={{ width: "20px", height: "15px" }} />
      <Typography
        sx={{
          fontFamily: "IBM Plex Sans",
          color: "white",
          fontSize: "20px",
          fontWeight: "400",
          lineHeight: "26px",
          textAlign: "left",
        }}
      >
        {arrowText}
      </Typography>
    </Stack>
  );
};

export default TabText;
